import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppStateService } from '@core/services/app-state.service';

@Component({
    selector: 'app-update-dialog',
    templateUrl: './update-dialog.component.html',
    styleUrls: ['./update-dialog.component.scss'],
    standalone: false
})
export class UpdateDialogComponent implements OnInit {

  constructor(
    private appStateService:AppStateService,
    private dialogRef:MatDialogRef<UpdateDialogComponent>) { }
  ngOnInit(): void {
  }

  update(){
    this.appStateService.updatePrompt();
    this.dialogRef.close();
  }
}
